/** Shared Tailwind class strings for Control Center data tables. */

export const thCls =
  'px-4 py-4 text-sm font-medium text-text-tertiary whitespace-nowrap'

export const thSortBtnCls =
  'inline-flex items-center gap-0.5 cursor-pointer select-none hover:text-text-secondary'

export const tdCls = 'px-4 py-3.5 text-sm text-text-secondary'
